module.exports = __webpack_public_path__ + "img/xzy.2286de40.gif";